import { useEffect, useState } from "react";
import { useActiveLocation } from "../activeLocation";
import { loadStoredValue, storeValue } from "../storedValue";
import { CustomerOperationsView, PERIODS, type Period } from "./CustomerOperationsView";
import { OperationsFilter } from "./types";
import { useCustomerOperations } from "./useCustomerOperations";

const PERIOD_STORAGE_KEY = "robotics-customer-operations-period";

export function createCustomerOperations() {
  return function CustomerOperations() {
    const { locationId, name } = useActiveLocation();
    const [period, setPeriod] = useState<Period>(() => loadStoredValue(PERIOD_STORAGE_KEY, PERIODS, "7"));
    useEffect(() => storeValue(PERIOD_STORAGE_KEY, period), [period]);

    // Page resets to 1 whenever the location, filter or period changes.
    const [view, setView] = useState({ locationId, period, filter: "All" as OperationsFilter, page: 1 });
    const current =
      view.locationId === locationId && view.period === period ? view : { locationId, period, filter: view.filter, page: 1 };
    const query = useCustomerOperations(locationId, current.page, current.filter, Number(period));

    return (
      <CustomerOperationsView
        data={query.data}
        isLoading={query.isLoading}
        isError={query.isError}
        error={query.error}
        locationId={locationId}
        locationLabel={name}
        filter={current.filter}
        onFilterChange={(filter) => setView({ ...current, filter, page: 1 })}
        period={period}
        onPeriodChange={setPeriod}
        page={current.page}
        onPageChange={(page) => setView({ ...current, page })}
      />
    );
  };
}
